import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/orders/")({
  head: () => ({ meta: [{ title: "My Orders | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/account-orders-index")),
});
